import Grid from "@material-ui/core/Grid";

const grid = ({ children, ...otherProps }) => {
  return <Grid {...otherProps}>{children}</Grid>;
};

export default grid;
